import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { instructionsApi } from 'src/Services/API';
import { SectionsDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useGenerateInstruction = (
  options?: UseMutationOptions<SectionsDto, unknown, string>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<SectionsDto, unknown, string>(
    ['generate-instruction', assetId],
    async (title: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await instructionsApi.instructionsControllerGenerateContent(assetId, {
        title,
      });
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Instruction', 'generate', variables);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
